<template>
  <a-modal centered :visible="visible" title="添加商标" @ok="on_submit" @cancel="cancel" :confirmLoading="submitting"
           :width="420">
    <a-form-model :model="form" ref="trademark_create" :rules="rules" layout="vertical">
      <a-form-model-item label="注册号" prop="applyNo">
        <a-input v-model="form.applyNo" allowClear />
      </a-form-model-item>

      <a-form-model-item label="分类号" prop="internationalGroup">
        <a-input v-model="form.internationalGroup" allowClear />
      </a-form-model-item>

      <a-form-model-item label="成本价" prop="price">
        <a-input-number
            style="width: 200px"
            :min="1" :max="1000000"
            v-model="form.price" allowClear />
      </a-form-model-item>

      <a-form-model-item label="售价" prop="sell_price">
        <a-input-number
            style="width: 200px"
            :min="1" :max="1000000" v-model="form.sell_price" allowClear />
      </a-form-model-item>

      <a-form-item name="tradestatus" label="商标状态" prop="tradestatus">
        <a-select v-model:value="form.tradestatus" :options="initTradestatus" />
      </a-form-item>

      <a-form-model-item label="商标图片" prop="imgUrl">
        <a-upload
            list-type="picture-card"
            name="file"
            :action="action"
            :withCredentials="true"
            :show-upload-list="false"
            @change="(info) => on_upload_change(info, 'imgUrl')"
            accept="image/png, image/jpeg"
        >
          <img v-if="form.imgUrl" :src="form.imgUrl" style="width:100%" />

          <div v-else>
            <a-icon :type="uploading ? 'loading' : 'plus'" />
            <div class="ant-upload-text">
              上传
            </div>
          </div>
        </a-upload>
      </a-form-model-item>

      <a-form-model-item label="备注">
        <a-textarea v-model="form.remark" allowClear />
      </a-form-model-item>
    </a-form-model>
  </a-modal>
</template>
<script>
import env from "../../../../env";

let init_form = {
  price: null,
  sell_price: null,
  remark: null,
  imgUrl: null,
  tradestatus: null,
  internationalGroup: null,
  applyNo: null,
  supplier_id: null,
};
export default {
  props: {
    visible: {
      default: false
    },
    record: null,
    callback: null,
    supplier_id:null,
  },
  data() {
    return {
      initTradestatus : [
        { label: '已初审', value: '已初审' },
        { label: '已注册', value: '已注册' },
        { label: '已转让', value: '已转让' },
        { label: '已暂停', value: '已暂停' },
      ],
      uploading: false,
      action: env.base_url + "service/upload",
      submitting: false,
      form: {},
      rules: {
        applyNo: [
          {
            required: true,
            trigger: ["change", "blur"],
            message: "注册号"
          }
        ],
        internationalGroup: [
          {
            required: true,
            trigger: ["change", "blur"],
            message: "分类号"
          }
        ],
        tradestatus: [
          {
            required: true,
            trigger: ["change", "blur"],
            message: "必填"
          }
        ],
        sell_price: [
          {
            required: true,
            trigger: ["change", "blur"],
            message: "必填"
          }
        ],
        price: [
          {
            required: true,
            trigger: ["change", "blur"],
            message: "必填"
          }
        ],
      }
    };
  },
  created() {
    this.form = JSON.parse(JSON.stringify(init_form));
  },
  watch: {
    visible(v) {
      if (v && this.record) {
        this.supplier_id = this.record
        /*Object.keys(this.form).map((v) => {
          if (Object.prototype.hasOwnProperty.call(this.record, v)) {
            switch (v) {
              case "is_include_invoice":
              case "is_include_transfer":
              case "is_include_notary":
                this.form[v] = !!this.record[v];
                break;
              default:
                this.form[v] = this.record[v];
            }
          }
        });*/
      }
    }
  },
  methods: {
    cancel() {
      this.$emit("close");
    },
    on_submit() {
      this.$refs["trademark_create"].validate((valid) => {
        if (valid) {
          this.submitting = true;
          this.$http
            .post("/trademark/store/" + this.supplier_id, this.form)
            .then((res) => {
              if (res.success) {
                this.cancel();
                if (this.callback) {
                  this.callback(JSON.parse(JSON.stringify(this.form)));
                }
              } else {
                this.$error({ title: "失败", centered: true, content: res.message });
              }
            })
            .catch(() => {
            })
            .then(() => {
              this.submitting = false;
            });
        } else {
          this.$message.error("请检查并填写完需要录入的内容");
          return false;
        }
      });
    },

    after_close() {
      this.$refs["trademark_create"].resetFields();

      this.form = JSON.parse(JSON.stringify(init_form));
    },

    on_upload_change(info, field) {
      if (info.file.status === "uploading") {
        this.uploading = true;
        return;
      }
      if (info.file.status === "done") {
        this.uploading = false;
        if (info.file.response.success) {
          this.form[field] = info.file.response.data.url;
        } else {
          this.$error({
            title: "失败",
            content: info.file.response.message,
          });
        }
      } else if (info.file.status === "error") {
        this.$message.error(`${info.file.name} 上传失败.`);
      }
    },
  }
};
</script>
